import { useQuery } from '@tanstack/react-query'
import { cpGetLineOADashboard } from '@/lib/api/controlPlaneClient'
import { useAuthStore } from '@/lib/store/authStore'

export const LINE_OA_DASHBOARD_KEY = ['line-oa-dashboard'] as const

export function useLineOADashboard(options?: { enabled?: boolean }) {
  const activeStorefrontKey = useAuthStore((s) => s.activeStorefrontKey)
  return useQuery({
    queryKey: [...LINE_OA_DASHBOARD_KEY, activeStorefrontKey],
    queryFn: cpGetLineOADashboard,
    staleTime: 3 * 60 * 1000, // 3 min
    enabled: options?.enabled !== false,
  })
}
